import { Component, Input, OnInit } from '@angular/core';
import { finalize, Subject, takeUntil, tap } from 'rxjs';
import { RemindersCalendarService } from '../../../reminders/reminders-calendar/reminders-calendar.service';
import { TReminder } from '../../../reminders/reminders.consts';
import { RemindersService } from '../../../reminders/reminders.service';

@Component({
  selector: 'pp-point-reminders-list',
  templateUrl: './point-reminders-list.component.html',
  styleUrls: ['./point-reminders-list.component.scss'],
  standalone: false,
})
export class PointRemindersListComponent implements OnInit {
  @Input() ppPointId = '';
  private readonly destroy$ = new Subject<void>();

  reminders: TReminder[] = [];
  processing = false;

  constructor(
    private remindersService: RemindersService,
    private remindersCalendarService: RemindersCalendarService,
  ) {}

  ngOnInit(): void {
    this.updateList();

    this.remindersService.remindersChanged$
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.updateList()),
      )
      .subscribe();
  }

  updateList(): void {
    this.processing = true;

    this.remindersService
      .fetchRemindersForPoint(this.ppPointId)
      .pipe(
        tap((reminders) => {
          this.reminders = reminders;
          this.sortList();
        }),
        finalize(() => {
          this.processing = false;
        }),
      )
      .subscribe();
  }

  sortList(): void {
    this.reminders = this.remindersCalendarService.sortReminders(this.reminders);
  }
}
